import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { get_order_details } from "../../store/reducers/orderReducer";
import { formatOrderDate } from "../../utils/orderDate";

const OrderDetails = () => {
  const { orderId } = useParams();
  const dispatch = useDispatch();

  const { userInfo } = useSelector(state => state.auth);
  const { myOrder } = useSelector(state => state.order);

  useEffect(() => {
    dispatch(get_order_details(orderId));
  }, [orderId, dispatch]);

  return (
    <div className="bg-white p-5">
      <h2 className="text-slate-600 font-semibold">
        <span className="font-mono text-[#ae1d22] text-lg">{myOrder.orderCode || `#${myOrder._id}`}</span>{" "}
        <span className="pl-1 text-sm font-normal">
          {formatOrderDate(myOrder)}
        </span>{" "}
      </h2>
      <div className="grid grid-cols-2 gap-3">
        <div className="flex flex-col gap-1">
          <h2 className="text-slate-600 font-semibold font-sans">Para envio : {myOrder.shippingInfo?.name} </h2>
          <p>
            <span className="bg-blue-100 text-blue-800 text-xs font-medium mr-2 px-2 py-2 rounded">Inicio</span>
            <span className="text-slate-600 text-sm">
              {myOrder.shippingInfo?.address}
              {myOrder.shippingInfo?.province}
              {myOrder.shippingInfo?.city}
            </span>
          </p>
          <p className="text-slate-600 text-sm ">
            Tipo Comprobante: {myOrder.shippingInfo?.tipoComprobante}- {myOrder.shippingInfo?.numeroComprobante}{" "}
          </p>
          <p className="text-slate-600 text-md font-semibold">Para Correo {userInfo.email}</p>
        </div>

        <div className="text-slate-600">
          <h2 className="font-mono">Precio : S/{myOrder.price} Incluido envío</h2>
          <p className="font-mono">
            {" "}
            Estado de Pago :{" "}
            <span className={`py-[1px] text-xs px-3 ${myOrder.payment_status === "paid" ? "bg-green-300 text-[#ae1d22]" : "bg-red-300 text-red-800"} rounded-md`}> {myOrder.payment_status} </span>{" "}
          </p>

          <p className="font-mono">
            {" "}
            Estado de Pedido :{" "}
            <span className={`py-[1px] text-xs px-3 ${myOrder.delivery_status === "paid" ? "bg-green-300 text-[#ae1d22]" : "bg-red-300 text-red-800"} rounded-md`}>
              {" "}
              {myOrder.delivery_status}{" "}
            </span>{" "}
          </p>
        </div>
      </div>

      <div className="mt-4">
        <h2 className="text-slate-600 text-lg pb-2 font-sans font-bold">Productos Pedidos </h2>
        <div className="flex gap-5 flex-col">
          {myOrder.products?.map((p, i) => {
            const unitPrice = p.discount > 0 ? p.discount : p.price;
            const discountPercent =
              p.discount > 0 && p.price > 0
                ? Math.round(((p.price - p.discount) / p.price) * 100)
                : 0;
            const total = unitPrice * (p.quantity || 1);

            return (
            <div key={i}>
              <div className="flex gap-5 justify-start items-center text-slate-600">
                <div className="flex gap-2">
                  <img className="w-[55px] h-[55px]" src={p.image} alt="" />
                  <div className="flex text-sm flex-col justify-start items-start">
                    <Link> {p.name} </Link>
                    <p>
                      {" "}
                      <span>Marca : {p.brand}</span>{" "}
                    </p>

                    <p>
                      {" "}
                      <span>Sku : {p.sku}</span>{" "}
                    </p>

                    <p>
                      {" "}
                      <span>Talla : {p.size}</span>{" "}
                    </p>

                    <p>
                      <span>Cantidad : {p.quantity}</span>
                    </p>
                  </div>
                </div>

                <div className="pl-4 flex flex-col">
                  <p className="text-xs text-slate-500">Precio unitario</p>
                  <h2 className="text-md text-green-800">S/{unitPrice.toFixed(2)}</h2>
                  {p.discount > 0 && (
                    <>
                      <p className="text-xs text-slate-500">Precio original</p>
                      <p className="line-through">S/{Number(p.price).toFixed(2)}</p>
                      <p className="text-xs text-slate-500">Descuento</p>
                      <p>-{discountPercent}%</p>
                    </>
                  )}
                  <p className="text-xs text-slate-500">Total</p>
                  <p className="font-semibold text-[#ae1d22]">S/{total.toFixed(2)}</p>
                </div>
              </div>
            </div>
          );
          })}
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
